import React from 'react'

export const WelcomeView = () => {
  return (
    <>
      <h1>Welcome to the App!</h1>
      <p>
        If you are a company manager, create or select a company by clicking the
        dropdown menu above, then create or select a project.
      </p>
      <p>
        If you do not have a company, you will need to wait until you are
        invited to a company or project.
      </p>
    </>
  )
}
